import TimeUnitDropdown from "components/basic/dropdowns/time-unit-dropdown/TimeUnitDropdown";
import { InputNumber, InputNumberValueChangeEvent } from "primereact/inputnumber";
import React, { FC, useEffect, useState } from "react";
import { T } from "services/lang/LanguageService";
import { DashboardEditorProps } from "components/ComponentTypeTypes";
import { DropdownChangeEvent } from "primereact/dropdown";
import { ComponentTheme, DweenTimeUnitEnum } from "utils/enums";
import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import { DatasetStatusControllerProps } from "../DatasetStatusControllerTypes";

const defaultDatasetStatusControllerConfig: DatasetStatusControllerProps = {
  config: {
    alignStartTo: DweenTimeUnitEnum.HOURS,
    timeOffset: 0,
    timeOffsetUnits: DweenTimeUnitEnum.HOURS,
    dataFrequency: DweenTimeUnitEnum.HOURS,
    updateFrequency: 5,
  },
  identifier: "",
  theme: ComponentTheme.TRANSPARENT,
};

const DatasetStatusControllerEditor: FC<DashboardEditorProps<DatasetStatusControllerProps>> = ({
  config,
  onConfigChange,
}) => {
  const conf: DatasetStatusControllerProps =
    config && Object.keys(config).length !== 0 ? config : defaultDatasetStatusControllerConfig;
  const [currentConfig, setCurrentConfig] = useState<DatasetStatusControllerProps>(conf);

  useEffect(() => onConfigChange(currentConfig), [currentConfig]);

  const handleConfigChange = (e: InputNumberValueChangeEvent | DropdownChangeEvent) => {
    setCurrentConfig({
      ...currentConfig,
      config: {
        ...currentConfig.config,
        [e.target.id]: e.target.value?.toString().toUpperCase(),
      },
    });
  };

  const handleDatasetChange = (value: string | null) => {
    setCurrentConfig({ ...currentConfig, identifier: value ?? "" });
  };

  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-column gap-2 w-8">
        <label htmlFor="valueDataset">{T("word.dataset")}</label>
        <DatasetDropdown value={currentConfig.identifier ?? ""} onChange={handleDatasetChange} />
      </div>
      <div className="flex w-12 justify-content-start">
        <div className="col-4 gap-2 flex flex-column">
          <label htmlFor="timeOffset">{T("load-conf.time-offset")}</label>
          <div className="p-inputgroup">
            <InputNumber
              id="timeOffset"
              className="w-6"
              value={currentConfig.config?.timeOffset as number}
              onValueChange={handleConfigChange}
            />
            <TimeUnitDropdown
              id="timeOffsetUnits"
              className="p-inputgroup-addon p-0 w-6"
              value={currentConfig.config?.timeOffsetUnits ? currentConfig.config.timeOffsetUnits : ""}
              onChange={handleConfigChange}
            />
          </div>
        </div>
        <div className="col-2 gap-2 flex flex-column">
          <label htmlFor="dataFrequency">{T("config.data-frequency")}</label>
          <TimeUnitDropdown
            id="dataFrequency"
            className="p-0 w-full"
            value={currentConfig.config?.dataFrequency ? currentConfig.config.dataFrequency : ""}
            onChange={handleConfigChange}
          />
        </div>
        <div className="col-2 gap-2 flex flex-column">
          <label htmlFor="alignStartTo">{T("load-conf.align-start-to")}</label>
          <TimeUnitDropdown
            id="alignStartTo"
            className="p-0 w-full"
            value={currentConfig.config?.alignStartTo ? currentConfig.config.alignStartTo : ""}
            onChange={handleConfigChange}
          />
        </div>
        <div className="col-2 gap-2 flex flex-column">
          <label htmlFor="updateFrequency">{T("load-conf.update-frequency")}</label>
          <div className="p-inputgroup w-full">
            <InputNumber
              id="updateFrequency"
              className="p-0 w-full"
              value={currentConfig.config?.updateFrequency as number}
              onValueChange={handleConfigChange}
            />
            <span className="p-inputgroup-addon">s</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatasetStatusControllerEditor;
